"use strict";

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es6.object.freeze");

var _throttle = _interopRequireDefault(require("lodash-es/throttle"));

var _utils = require("../helpers/utils");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
/**
 * Mixin: Scroll direction
 * ------------------------------------------------------------------------------
 * An event-based mixin to fire events when scroll direction has changed
 *
 * @namespace scrollDirection
 */

/**
 * Create a new scroll direction helper object.
 */


var _default = function _default(config) {
  /**
   * Instance default settings.
   */
  var defaults = {
    threshold: 5,
    throttle: 250,
    start: 100
  };
  /**
   * Instance settings.
   */

  var settings = (0, _utils.extendDefaults)(defaults, config);
  var previousScrollTop = 0;
  var currentScrollDirection = '';
  var newScrollDirection = '';
  /**
   * Set scrolling event with throttle parameter to limit the amount
   * the callback can fire
   */

  function setScrollingEvent() {
    (0, _utils.on)('scroll', (0, _throttle["default"])(handleScrollEvent, settings.throttle));
  }
  /**
   * Handle scrolling events using scroll top position.
   */


  function handleScrollEvent() {
    var scrollPosition = window.pageYOffset;
    setScrollState(scrollPosition);
  }
  /**
   * Set new scrolling direction value and fire off event.
   * @param {Number} scrollPosition - The window offset/scroll position.
   */


  function setScrollState(scrollPosition) {
    var scrollState = detectScrollDirection(scrollPosition);

    if (typeof scrollState === 'undefined') {
      return;
    }

    if (scrollState !== currentScrollDirection) {
      currentScrollDirection = newScrollDirection;
      Frame.EventBus.emit('ScrollDirection:changed', newScrollDirection);
    }
  }
  /**
   * Get the new scroll direction string.
   * @param {Number} scrollPosition - The window offset/scroll position.
   * @returns {string} New scroll direction string (at-top, up, down).
   */


  function detectScrollDirection(scrollPosition) {
    if (Math.abs(previousScrollTop - scrollPosition) <= settings.threshold) {
      return newScrollDirection;
    }

    if (scrollPosition > previousScrollTop && scrollPosition > settings.start) {
      Frame.EventBus.emit('ScrollDirection:down', 'down');
      newScrollDirection = 'down';
    } else {
      Frame.EventBus.emit('ScrollDirection:up', 'up');
      newScrollDirection = 'up';
    }

    if (scrollPosition <= settings.start + 10) {
      Frame.EventBus.emit('ScrollDirection:top', 'at-top');
      newScrollDirection = 'at-top';
    }

    previousScrollTop = scrollPosition;
    return newScrollDirection;
  }
  /**
   * Pure function to get current scrolling direction value.
   */


  function getScrollDirection() {
    return currentScrollDirection;
  }
  /**
   * Public interface.
   */


  return Object.freeze({
    init: setScrollingEvent,
    get: getScrollDirection
  });
};

exports["default"] = _default;